import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import EditLiveCategory from "../components/Live/EditCategory";

const EditLiveCategoryScreen = ({match}) => {
  const categoryId = match.params.id;
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <EditLiveCategory categoryId={categoryId}/>
      </main>
    </>
  );
};

export default EditLiveCategoryScreen;
